exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card{\n    border: 1px solid #dadada;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: #fff;\n    margin-top: 10px;    \n}\n\n.mycredits{\n    width: 25%;\n    height: 267px;\n    margin-left: 20px;\n}\n\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main